import React from "react";
import {
  Grid,
  Typography,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Box,
} from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Header from "./Header";
import Footer from "./Footer";
import DescriptionIcon from "@mui/icons-material/Description";

const termsData = [
  {
    title: "Acceptance of Terms",
    description:
      "Opening or using GetMyRank signifies the users' acceptance of the Terms & Conditions of the website and its services along with a declaration that they have read, understood and agreed to be bound by the Terms & Conditions.",
  },
  {
    title: "Free Educational Access",
    description:
      "GetMyRank provides free access to syllabus information, study resources, and previous year question papers solely for learning and reference purposes without any mandatory registration or payment.",
  },
  {
    title: "Content Purpose & Accuracy",
    description:
      "All contents present on GetMyRank are only for educational guidance. We strive to maintain accuracy, but do not guarantee completeness or official representation.",
  },
  {
    title: "Use of Study Materials",
    description:
      "Users may access and share GetMyRank content only for personal academic purposes; commercial use or redistribution without permission is forbidden.",
  },
  {
    title: "Exam & University References",
    description:
      "References to SSLC, PUC, Degree, B.Tech, entrance exams, and competitive exams are informational and not affiliated with any education board or university.",
  },
  {
    title: "Intellectual Property Rights",
    description:
      "All original content, branding, and presentation on GetMyRank are protected and may not be copied, modified, or reproduced without written consent.",
  },
  {
    title: "External Links & Resources",
    description:
      "GetMyRank may include links to third-party educational resources, but we are not responsible for their accuracy, availability, or policies.",
  },
  {
    title: "User Responsibility",
    description:
      "Users should verify materials for academic needs and check official sources before using content in exams.",
  },
  {
    title: "Updates to Terms",
    description:
      "These Terms & Conditions may be updated periodically, and continued use indicates acceptance of revised terms.",
  },
];

const TermsandConditions = () => {
  return (
    <>
      <Header />

      {/* Professional Header */}
      <Box
        sx={{
          minHeight: {xs:"10vh",md:'20vh'},
          background: "linear-gradient(135deg, #0D2A54 0%, #1A4B83 50%, #2B6BA5 100%)",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",

          gap: { xs: 1, sm: 2 },
          px: 3,
        }}
      >
        <DescriptionIcon
          sx={{
            fontSize: { xs: 30, sm: 40, md: 40 },
            color: "white",
            textShadow: "1px 2px 5px rgba(0,0,0,0.5)",
          }}
        />
        <Typography
          sx={{
            color: "white",
            fontWeight: 900,
            fontSize: { xs: 24, sm: 32, md: 40 },
            textAlign: { xs: "center", sm: "left" },
            textShadow: "1px 2px 6px rgba(0,0,0,0.4)",
          }}
        >
          Terms and Conditions
        </Typography>
      </Box>

      {/* Intro Section */}
      <Grid container justifyContent="center" sx={{ p: { xs: 2, md: 8 } }}>
        <Grid item xs={12} md={10} sx={{ mb: 5, textAlign: "center" }}>

          <Typography
            sx={{
              fontSize: { xs: 16, md: 18 },
              color: "#333",
              lineHeight: 1.7,
              mt: -2
            }}
          >
            GetMyRank is a no-cost educational portal that aims to provide students with easy access to the syllabus, study resources, and question papers from the previous year for SSLC, PUC, Degree, Ug, Pg, and different academic, competitive, and entrance exams.
          </Typography>
          <Typography
            sx={{
              fontSize: { xs: 16, md: 18 },
              color: "#333",
              mt: 2,
              lineHeight: 1.7,
            }}
          >
            The use of this website implies that users accept and abide by the terms set out below which are meant to guarantee, fair use of the site, the integrity of the content provided, and a safe learning environment for all.
          </Typography>
        </Grid>

        {/* Accordion Section */}
        <Grid size={{xs:12,md:10,sm:10}}>
          {termsData.map((item, index) => (
            <Accordion
              key={index}
              sx={{
                mb: 2,
                borderRadius: 3,
                boxShadow: 3,
                transition: "transform 0.2s",
                "&:hover": { transform: "scale(1.01)" },
                "&:before": { display: "none" },
              }}
            >
              <AccordionSummary expandIcon={<ExpandMoreIcon />} sx={{ minHeight: 70 }}>
                <Typography fontWeight="bold" sx={{ fontSize: { xs: 16, md: 18 } }}>
                  {index + 1}. {item.title}
                </Typography>
              </AccordionSummary>
              <AccordionDetails>
                <Typography sx={{ fontSize: { xs: 15, md: 16 }, lineHeight: 1.6 }}>
                  {item.description}
                </Typography>
              </AccordionDetails>
            </Accordion>
          ))}
        </Grid>
      </Grid>

      <Footer />
    </>
  );
};

export default TermsandConditions;
